module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-item",
    attrs: {
      "loading": "loading"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.model.partnerDealId) + "\n    "), _c('section', {
    staticClass: "product-item-content"
  }, [_c('v-tabs', {
    ref: "tabs",
    staticClass: "fixed-header-content",
    attrs: {
      "active-name": _vm.activeIndex
    },
    on: {
      "tab-click": _vm.tabChange
    }
  }, [_c('v-tab-pane', {
    attrs: {
      "label": "产品基本信息"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showErrorOnTabs && _vm.errors[0] && _vm.errors[0].items && _vm.errors[0].items['tab1'] && _vm.errors[0].items['tab1'].length > 0),
      expression: "showErrorOnTabs && errors[0] && errors[0].items && errors[0].items['tab1'] && errors[0].items['tab1'].length > 0"
    }],
    staticClass: "icon-info help-icon tab-error-icon",
    slot: "title"
  }), _vm._v(" "), _c('info', {
    ref: "info",
    attrs: {
      "model": _vm.model,
      "errors": _vm.errors,
      "validate": _vm.tabs[0].status,
      "mode": _vm.mode,
      "extra": _vm.extra,
      "loaded": _vm.modelLoaded
    },
    on: {
      "update:model": function($event) {
        _vm.model = $event
      },
      "updateMsRatio": _vm.updateMsRatio,
      "update:errors": function($event) {
        _vm.errors = $event
      },
      "update:validate": function($event) {
        _vm.tabs[0].status = $event
      }
    }
  })], 1), _vm._v(" "), _c('v-tab-pane', {
    attrs: {
      "label": "购买使用说明"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showErrorOnTabs && _vm.errors[0] && _vm.errors[0].items && _vm.errors[0].items['tab2'] && _vm.errors[0].items['tab2'].length > 0),
      expression: "showErrorOnTabs && errors[0] && errors[0].items && errors[0].items['tab2'] && errors[0].items['tab2'].length > 0"
    }],
    staticClass: "icon-info help-icon tab-error-icon",
    slot: "title"
  }), _vm._v(" "), _c('instruction', {
    attrs: {
      "model": _vm.model,
      "validate": _vm.tabs[1].status,
      "errors": _vm.errors,
      "mode": _vm.mode,
      "extra": _vm.extra
    },
    on: {
      "update:model": function($event) {
        _vm.model = $event
      },
      "update:validate": function($event) {
        _vm.tabs[1].status = $event
      },
      "update:errors": function($event) {
        _vm.errors = $event
      }
    }
  })], 1), _vm._v(" "), _c('v-tab-pane', {
    attrs: {
      "label": "价格/库存/有效期"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showErrorOnTabs && _vm.errors[0] && _vm.errors[0].items && _vm.errors[0].items['tab3'] && _vm.errors[0].items['tab3'].length > 0),
      expression: "showErrorOnTabs && errors[0] && errors[0].items && errors[0].items['tab3'] && errors[0].items['tab3'].length > 0"
    }],
    staticClass: "icon-info help-icon tab-error-icon",
    slot: "title"
  }), _vm._v(" "), _c('price', {
    ref: "price",
    attrs: {
      "model": _vm.model,
      "errors": _vm.errors,
      "extra": _vm.extra,
      "mode": _vm.mode
    },
    on: {
      "update:model": function($event) {
        _vm.model = $event
      },
      "update:errors": function($event) {
        _vm.errors = $event
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "row button-area"
  }, [_c('div', {
    staticClass: "col-sm-4 col-sm-offset-2"
  }, [_c('v-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex > 1),
      expression: "activeIndex > 1"
    }],
    attrs: {
      "disabled": _vm.activeIndex == 1,
      "content": "上一步",
      "type": "primary"
    },
    on: {
      "click": _vm.prevStep
    }
  }), _vm._v(" "), _c('v-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode != 'new' || _vm.activeIndex == _vm.tabs.length),
      expression: "mode != 'new' || activeIndex== tabs.length"
    }],
    attrs: {
      "disabled": _vm.mode == 'readonly',
      "content": "保存",
      "type": "primary"
    },
    on: {
      "click": _vm.saveModel
    }
  }), _vm._v(" "), _c('v-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode != 'new' || _vm.activeIndex == _vm.tabs.length),
      expression: "mode != 'new' || activeIndex== tabs.length"
    }],
    attrs: {
      "disabled": _vm.mode == 'readonly',
      "content": "保存并提交审核",
      "type": "warning"
    },
    on: {
      "click": _vm.saveAndCheck
    }
  }), _vm._v(" "), _c('v-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex < _vm.tabs.length),
      expression: "activeIndex < tabs.length"
    }],
    attrs: {
      "disabled": _vm.activeIndex == _vm.tabs.length,
      "content": "下一步",
      "type": "primary"
    },
    on: {
      "click": _vm.nextStep
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mode != 'readonly') ? _c('preview', {
    staticClass: "preview-product",
    attrs: {
      "url": _vm.previewUrl
    }
  }, [(_vm.previewShowTrigger) ? _c('button', {
    staticClass: "btn btn-sm btn-warning",
    on: {
      "click": function($event) {
        _vm.previewShowTrigger = false
      }
    }
  }, [_vm._v("X")]) : _vm._e(), _vm._v(" "), (_vm.previewShowTrigger) ? _c('button', {
    staticClass: "btn btn-sm btn-warning",
    on: {
      "click": function($event) {
        _vm.saveAndPreview()
      }
    }
  }, [_vm._v("更新手机并预览产品")]) : _vm._e(), _vm._v(" "), (!_vm.previewShowTrigger) ? _c('button', {
    staticClass: "btn btn-sm btn-warning",
    on: {
      "click": function($event) {
        _vm.saveAndPreview()
      }
    }
  }, [_vm._v("保存并手机预览产品")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('te-hui-apply', {
    attrs: {
      "options": _vm.teHuiOption,
      "show": _vm.teHuiShow
    },
    on: {
      "update:show": function($event) {
        _vm.teHuiShow = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-750bbfee","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ticket/product/item/Main.vue
// module id = 583
// module chunks = 0